import { RECURRING_TRANSFER_FREQUENCY_OPTIONS } from "../domains/transactions/recurring-transfer";

export const formatFrequency = (interval: number, unit: string, formatMessage: (id: string) => string): string => {
  const frequencyOption = RECURRING_TRANSFER_FREQUENCY_OPTIONS.find(
    (freqOpt) => freqOpt.frequency.interval === interval && freqOpt.frequency.unit === unit,
  );
  return frequencyOption ? formatMessage(frequencyOption.label) : "-";
};
